export function appendCursorParams(path, query = {}) {
    const url = new URL(path, 'https://mira.local');
    if (query.cursor)
        url.searchParams.set('cursor', query.cursor);
    if (query.limit)
        url.searchParams.set('limit', String(query.limit));
    return `${url.pathname}${url.search}`;
}
export function hasNextPage(page) {
    return Boolean(page.nextCursor);
}
